var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "bg_gray" }),
    _c("div", { staticClass: "onlineRetailers" }, [
      _c("header", { staticClass: "head" }),
      _c(
        "nav",
        { staticClass: "bigBox" },
        [
          _vm._l(_vm.data, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "box",
                on: {
                  click: function($event) {
                    return _vm.seeDetails(item)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "img" },
                  [
                    _c("van-image", {
                      attrs: { "lazy-load": "", src: item.img },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "loading",
                            fn: function() {
                              return [
                                _c("van-loading", {
                                  attrs: { type: "spinner", size: "20" }
                                })
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "error",
                            fn: function() {
                              return [_vm._v("加载失败")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _c("h2", { staticClass: "title van-multi-ellipsis--l2" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _c("div", { staticClass: "cost" }, [
                  _vm._v("基础工费: "),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.cost.Basics) + "元/g")
                  ]),
                  _vm._v(" 附加费: "),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.cost.additional) + "元/g")
                  ])
                ]),
                _c("div", { staticClass: "dataInfo" }, [
                  _c("div", { staticClass: "weight" }, [
                    _vm._v("克重: " + _vm._s(item.weight.toFixed(2)) + "g ")
                  ]),
                  _c("div", { staticClass: "save" }, [
                    _vm._v("库存: " + _vm._s(item.save) + " ")
                  ])
                ]),
                _c("div", { staticClass: "money text" }, [
                  _vm._v(
                    " ¥" +
                      _vm._s(
                        (
                          Number(item.weight * _vm.pricehj) +
                          Number(_vm.cost.Basics * item.weight)
                        ).toFixed(2)
                      )
                  )
                ])
              ]
            )
          }),
          _c("div", { staticClass: "finished" }, [_vm._v("一 没有更多了 一")])
        ],
        2
      )
    ]),
    _c("footer", { staticClass: "foot" }, [
      _c("div", { staticClass: "flex-around" }, [
        _c("div", { on: { click: _vm.linkMall } }, [
          _vm._m(0),
          _c("div", { staticClass: "footerText" }, [_vm._v("商城")])
        ]),
        _c("div", { on: { click: _vm.linkCart } }, [
          _vm._m(1),
          _c("div", { staticClass: "footerText" }, [_vm._v("购物车")])
        ]),
        _c("div", { on: { click: _vm.linkMy } }, [
          _vm._m(2),
          _c("div", { staticClass: "footerText" }, [_vm._v("我的")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerboximg" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/icon_mall-sel@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerboximg" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/icon_trolley_nor@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerboximg" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/icon_personal_nor@2x.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }